<template>
  <div :key="componentKey">
    <Disclosure as="nav" class="bg-[#0064ff]" v-slot="{ open }">
      <div class="mx-auto px-2 sm:px-6 lg:px-20">
        <div class="relative flex h-16 items-center justify-between">
          <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
            <!-- Mobile menu button-->
            <DisclosureButton
              class="inline-flex items-center justify-center rounded-md p-2 text-white hover:bg-blue-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
              <Bars3Icon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
              <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
            </DisclosureButton>
          </div>
          <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
            <div class="flex flex-shrink-0 items-center">
              <img class="block h-8 w-auto lg:hidden cursor-pointer" src="@/assets/xs_odihnx_logo.png"
                @click="$router.push('/menu')" />
              <img class="hidden h-8 w-auto lg:block cursor-pointer" src="@/assets/odihnx.png"
                @click="$router.push('/menu')" />
            </div>
            <div class="hidden sm:ml-20 sm:flex font-semibold items-center justify-center">
              <div class="flex space-x-4 items-center justify-center">
                <NavbarContent v-for="item in navigation" :key="item.name" v-model:name="item.name"
                  v-model:href="item.href" v-model:current="item.current" v-model:referenceMenu="referenceMenu"
                  :changeContextMenu="changeContextMenu" v-model:showContextMenu="showContextMenu" class="relative" />
              </div>
            </div>
          </div>
          <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            <Menu as="div" class="relative ml-3 flex items-center">
              <div>
                <MenuButton class="flex p-2 text-sm focus:outline-none focus:ring-1 focus:ring-offset-2">
                  <p class="truncate-text hidden sm:flex text-white place-self-center mr-3 cursor-pointer text-[12px] font-medium"
                    :class="{ 'truncate': isMdOrSmaller }">
                    {{ truncatedName }}
                  </p>
                  <span class="sr-only">Open user menu</span>
                  <img class="h-9 w-9 rounded-full" src="@/assets/user-avatar.svg" />
                </MenuButton>
              </div>
              <transition enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                  class="absolute flex flex-nowrap justify-between right-0 z-10 mt-24 w-44 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <MenuItem v-slot="{ active }">
                  <a href="#" :class="[active ? 'bg-blue-100 rounded-lg' : '', 'px-4 font-medium items-center gap-2 w-full py-2 flex flex-nowrap justify-between text-sm text-gray-700']"
                    @click="logout">
                    <span>Cerrar sesión</span><img class="h-6 w-6" src="@/assets/logout.png" /></a>
                  </MenuItem>

                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>
      </div>

      <!-- Overlay oscuro para menú móvil -->
      <transition
        enter-active-class="transition-opacity duration-300 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <DisclosureButton v-if="open" as="div" class="fixed inset-0 bg-black bg-opacity-50 z-40 sm:hidden cursor-pointer" />
      </transition>

      <!-- Menú móvil deslizante -->
      <transition
        enter-active-class="transition-transform duration-300 ease-out"
        enter-from-class="-translate-x-full"
        enter-to-class="translate-x-0"
        leave-active-class="transition-transform duration-200 ease-in"
        leave-from-class="translate-x-0"
        leave-to-class="-translate-x-full"
      >
        <DisclosurePanel v-if="open" class="fixed top-16 left-0 h-[calc(100vh-4rem)] w-64 bg-[#0064ff] shadow-2xl z-50 sm:hidden overflow-y-auto">
          <div class="space-y-1 px-4 py-4">
            <DisclosureButton 
              v-for="item in navigation" 
              :key="item.name" 
              as="a" 
              :href="item.href"
              @click="$router.push(item.href)"
              :class="[
                item.current ? 'bg-blue-900 text-white' : 'text-white hover:bg-blue-700', 
                'block rounded-lg px-4 py-3 text-base font-medium transition-colors'
              ]"
              :aria-current="item.current ? 'page' : undefined"
            >
              {{ item.name }}
            </DisclosureButton>
          </div>
        </DisclosurePanel>
      </transition>
    </Disclosure>
  </div>
</template>

<script>
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems
} from '@headlessui/vue'
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline'
import NavbarContent from './NavbarContent.vue'
import { getCognitoUser, getCognitoUserRole, logout as cognitoLogout } from '@/utils/cognitoAuth.js'

export default {
  name: 'MenuNavbar',
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Bars3Icon,
    XMarkIcon,
    NavbarContent
  },
  data() {
    return {
      name: '',
      userRole: 0,
      navigation: [],
      showContextMenu: false,
      referenceMenu: '',
      isMdOrSmaller: false,
      componentKey: 0
    }
  },
  computed: {
    truncatedName() {
      if (this.isMdOrSmaller) {
        if (this.name.length > 7) {
          return this.name.slice(0, 7) + "..."
        } else {
          return this.name
        }
      } else {
        return this.name
      }
    }
  },
  created() {
    // Escuchar evento de autenticación completada
    window.addEventListener('cognito-auth-complete', this.handleAuthComplete)
    window.addEventListener('storage', this.handleStorageChange)

    // Inicializar después para evitar problemas de timing
    this.$nextTick(() => {
      this.initializeNavbar()
    })
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)

    // Verificar autenticación una vez más
    setTimeout(() => {
      this.initializeNavbar()
    }, 100)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize)
    window.removeEventListener('cognito-auth-complete', this.handleAuthComplete)
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    initializeNavbar() {

      // Obtener datos básicos
      const cognitoUser = getCognitoUser()
      const tokenRole = getCognitoUserRole()

      this.name = cognitoUser?.email || 'Usuario'
      this.userRole = tokenRole || cognitoUser?.role || 0

      // Construir menú base
      const baseMenu = []

      // Reservas - disponible para admin (rol 2) y superadmin (rol 1)
      if (this.userRole == 1 || this.userRole == 2) {
        baseMenu.push({
          name: 'Reservas',
          href: '/menu/bookings',
          current: false
        })
      }

      // Usuarios de Instalación - solo para superadmin (rol 1)
      if (this.userRole == 1) {
        baseMenu.push({
          name: 'Usuarios de Instalación',
          href: '/menu/admin/users',
          current: false
        })
      }

      // Dispositivos - solo para superadmin (rol 1)
      if (this.userRole == 1) {
        baseMenu.push({
          name: 'Dispositivos',
          href: '/menu/admin/devices-board',
          current: false
        })
      }

      // Auditorías - solo para superadmin (rol 1), ver docs/servicio-auditoria.
      // getOpeningHistory ya está protegido con @hasRole(SUPER_ADMIN) en el BFF; este
      // filtro es solo para no ofrecer la entrada al ADMIN de instalación en el menú.
      // Vive en el nivel general (no dentro del panel de control) a pedido del equipo.
      if (this.userRole == 1) {
        baseMenu.push({
          name: 'Auditorías',
          href: '/menu/admin/audit',
          current: false
        })
      }

      // CRÍTICO: Asignar el array construido a navigation
      this.navigation = [...baseMenu]
      this.componentKey = Date.now()

    },
    handleAuthComplete() {
      // Esperar un poco para que se complete el guardado en localStorage
      setTimeout(() => {
        this.initializeNavbar()
      }, 100)
    },
    handleStorageChange(event) {
      if (event.key === 'user' || event.key === 'token' || event.key === 'role') {
        this.initializeNavbar()
      }
    },
    logout() {
      cognitoLogout()
      this.$router.push('/')
    },
    changeContextMenu(value, name) {
      this.referenceMenu = name
      this.showContextMenu = value
    },
    checkScreenSize() {
      this.isMdOrSmaller = window.innerWidth < 768
    }
  }
}
</script>

<style scoped>
.truncate-text {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>